import get from 'lodash/get';
import {
  FETCH_CENTER_VACANCIES,
  FETCH_VACANCY_HISTORY,
  FETCH_MAKER_PENDING,
  STORE_VACANCY_CAP_BY_YEARS,
  RECALL_PENDING_PLAN,
  RECALL_MODAL_DATA,
  APPROVE_PLAN,
  REJECT_PLAN,
  REJECT_MODAL_DATA,
  UPDATE_MODAL_DATA,
  SUBMIT_PLAN_FOR_REVIEW,
  STORE_EDITED_PLANS,
} from './actionTypes';

import {
  CANCEL_CAPACITY_CHANGE_REQUEST,
  SUBMIT_VACANCY_PLANNING,
  APPROVE_CAPACITY_CHANGE_REQUEST,
  REJECT_CAPACITY_CHANGE_REQUEST,
  CAPACITY_DRAFTS_BY_FK_SCHOOL,
} from '../models/VacancyPlanningModels';
import { SkApolloRequest } from '../../utils/apolloUtils';
import { parseGraphQLError, actionHandlerWithFeatureFlag } from '../../utils';
import { FEATURE_FLAGS } from '../../utils/constants';
import { msGetListEnrollmentPlanningActivityLog } from '../../services/EnrolmentPlanningService';
import DatadogHandler from '../../utils/datadog';

const dispatchRecallPlan = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: RECALL_PENDING_PLAN,
    key: 'recallPlan',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchRejectOfPlan = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: REJECT_PLAN,
    key: 'planRejected',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchApprovalOfPlan = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: APPROVE_PLAN,
    key: 'planApproved',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchPendingRequests = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_MAKER_PENDING,
    key: 'pendingRequest',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchVacancyHistories = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_VACANCY_HISTORY,
    key: 'vacancyHistories',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchSubmitForApproval = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: SUBMIT_PLAN_FOR_REVIEW,
    key: 'submitPlan',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchVacancyYears = (dispatch, data = {}, year) => {
  dispatch({
    type: STORE_VACANCY_CAP_BY_YEARS,
    key: 'vacanciesByYear',
    value: {
      inProgress: !year,
      year,
      data,
    },
  });
};

const dispatchFetchVacancies = (
  dispatch,
  inProgress = true,
  data = {},
  error = null,
  year
) => {
  dispatch({
    type: FETCH_CENTER_VACANCIES,
    key: 'vacancies',
    value: {
      inProgress,
      year,
      data,
      error,
    },
  });
};

export const dispatchRejectModalData = data => async dispatch => {
  dispatch({
    type: REJECT_MODAL_DATA,
    key: 'rejectModalData',
    value: data,
  });
};

export const dispatchUpdateModalData = data => async dispatch => {
  dispatch({
    type: UPDATE_MODAL_DATA,
    KEY: 'updateModalData',
    value: data,
  });
};

export const storeEditedPlans = data => async dispatch => {
  dispatch({
    type: STORE_EDITED_PLANS,
    key: 'editedPlans',
    value: data,
  });
};

export const dispatchRecallModalData =
  (remark = '', id = 0, errors = null) =>
  async dispatch => {
    const value = {
      errors,
      remark,
      id,
    };

    dispatch({
      type: RECALL_MODAL_DATA,
      key: 'recallData',
      value,
    });
  };

export const submitCapacityPlan = reqData => async dispatch => {
  dispatchSubmitForApproval(dispatch);

  try {
    const result = await SkApolloRequest({
      params: {
        mutation: SUBMIT_VACANCY_PLANNING,
        variables: reqData,
      },
      type: 'mutation',
    });

    if (get(result, 'success')) {
      dispatchSubmitForApproval(dispatch, false, {
        data: result.data,
      });

      return result;
    }
    dispatchSubmitForApproval(dispatch, false, null, result.error);
    return result;
  } catch (error) {
    dispatchSubmitForApproval(dispatch, false, null, {
      data: reqData,
      error: parseGraphQLError(error),
    });
    throw error;
  }
};

export const rejectPlan =
  (id, remark = '') =>
  async dispatch => {
    dispatchRejectOfPlan(dispatch);
    const reqData = {
      DraftID: id,
      Remarks: remark,
    };

    try {
      const result = await SkApolloRequest({
        params: {
          mutation: REJECT_CAPACITY_CHANGE_REQUEST,
          variables: reqData,
        },
        type: 'mutation',
      });

      if (get(result, 'success')) {
        dispatchRejectOfPlan(dispatch, false, {
          data: result.data,
        });

        return result;
      }
      dispatchRejectOfPlan(dispatch, false, null, result.error);
      return result;
    } catch (error) {
      dispatchRejectOfPlan(dispatch, false, null, {
        data: reqData,
        error: parseGraphQLError(error),
      });
      throw error;
    }
  };

export const approvePlan = id => async dispatch => {
  dispatchApprovalOfPlan(dispatch);
  const reqData = {
    DraftID: id,
  };

  try {
    const result = await SkApolloRequest({
      params: {
        mutation: APPROVE_CAPACITY_CHANGE_REQUEST,
        variables: reqData,
      },
      type: 'mutation',
    });

    if (get(result, 'success')) {
      dispatchApprovalOfPlan(dispatch, false, {
        data: result.data,
      });
      return result;
    }
    dispatchApprovalOfPlan(dispatch, false, null, result.error);
    return result;
  } catch (error) {
    dispatchApprovalOfPlan(dispatch, false, null, {
      data: reqData,
      error: parseGraphQLError(error),
    });
    throw error;
  }
};

export const recallCapcityPlan = (remark, id) => async dispatch => {
  dispatchRecallPlan(dispatch);
  const reqData = {
    DraftID: id,
    Remarks: remark,
  };

  try {
    const result = await SkApolloRequest({
      params: {
        mutation: CANCEL_CAPACITY_CHANGE_REQUEST,
        variables: reqData,
      },
      type: 'mutation',
    });

    if (get(result, 'success')) {
      dispatchRecallPlan(dispatch, false, {
        data: result.data,
      });

      return result;
    }
    dispatchRecallPlan(dispatch, false, null, result.error);
    return result;
  } catch (error) {
    dispatchRecallPlan(dispatch, false, null, {
      data: reqData,
      error: parseGraphQLError(error),
    });
    throw error;
  }
};

export const monoRequestCapacityDraftsByFkSchool = async (
  dispatch,
  { reqData, dispatchFunc }
) => {
  try {
    const result = await SkApolloRequest({
      params: {
        query: CAPACITY_DRAFTS_BY_FK_SCHOOL,
        variables: reqData,
      },
      type: 'query',
    });

    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {}, 'error');

    dispatchFunc(dispatch, false, null, { error: ex.message });
    throw ex;
  }
};

export const requestCapacityDraftsByFkSchool = async (
  reqData,
  dispatch,
  dispatchFunc
) => {
  dispatchFunc(dispatch);

  try {
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetListEnrollmentPlanningActivityLog,
        monoHandler: monoRequestCapacityDraftsByFkSchool,
        extraData: { reqData, dispatchFunc },
      }
    );

    if (get(result, 'success')) {
      dispatchFunc(dispatch, false, {
        data: result.data,
      });
    } else {
      dispatchFunc(dispatch, false, null, result.error);
    }
    return result.data;
  } catch (ex) {
    dispatchFunc(dispatch, false, null, { error: ex.message });
    throw ex;
  }
};

export const fetchPendingRequests = reqData => async dispatch =>
  requestCapacityDraftsByFkSchool(reqData, dispatch, dispatchPendingRequests);

export const fetchVacancyHistories = reqData => async dispatch =>
  requestCapacityDraftsByFkSchool(
    reqData,
    dispatch,
    dispatchFetchVacancyHistories
  );

export const fetchVacanciesByYear = reqData => async dispatch => {
  const vacReqData = [];
  const capReqData = [];
  let year = '';
  dispatchVacancyYears(dispatch, null, null);

  reqData.forEach(eachData => {
    year = eachData.year;

    vacReqData.push({
      key: `_${eachData.key}`,
      CentreID: eachData.centre,
      ServiceLevel: eachData.level,
      Year: eachData.year,
      IsPublic: false,
    });

    capReqData.push({
      key: `_${eachData.key}`,
      IDCentre: eachData.centre,
      IDLevel: eachData.level,
      Year: eachData.year,
    });
  });

  const vacGql = `{
        Data {
            Count,Status,Month
        }
    }`;

  const capGql = `
    {
        data {
            ID,
            active,
            capacity,
            fkCentre,
            date,
            year,
            month
        }
    }`;

  try {
    const result = await SkApolloRequest({
      params: [
        {
          key: 'findAllVacancies',
          query: vacGql,
          variables: vacReqData,
        },
        {
          key: 'capacitiesByFkCentreFkLevelYear',
          query: capGql,
          variables: capReqData,
        },
      ],
      type: 'bulkQuery',
    });

    if (result.success) {
      dispatchVacancyYears(dispatch, result.data, year);
    } else {
      dispatchVacancyYears(dispatch, result.error, year);
    }

    return result;
  } catch (ex) {
    dispatchVacancyYears(dispatch, { error: ex.message }, null);
    console.error(`error fetching vacancies for year ${year}.`);
  }
};

export const fetchVacancies = reqData => async dispatch => {
  dispatchFetchVacancies(dispatch);
  const vacReqData = [];
  const capReqData = [];
  let year = '';
  reqData.forEach(eachData => {
    year = eachData.year;
    vacReqData.push({
      key: `_${eachData.key}`,
      CentreID: eachData.centre,
      ServiceLevel: eachData.level,
      Year: eachData.year,
      IsPublic: false,
    });

    capReqData.push({
      key: `_${eachData.key}`,
      IDCentre: eachData.centre,
      IDLevel: eachData.level,
      Year: eachData.year,
    });
  });

  const vacGql = `{
        Data {
            Count,Status,Month
        }
    }`;

  const capGql = `
    {
        data {
            ID,
            active,
            capacity,
            fkCentre,
            date,
            year,
            month
        }
    }`;

  try {
    const result = await SkApolloRequest({
      params: [
        {
          key: 'findAllVacancies',
          query: vacGql,
          variables: vacReqData,
        },
        {
          key: 'capacitiesByFkCentreFkLevelYear',
          query: capGql,
          variables: capReqData,
        },
      ],
      type: 'bulkQuery',
    });

    if (result.success) {
      dispatchVacancyYears(dispatch, result.data, year);
      dispatchFetchVacancies(
        dispatch,
        false,
        {
          data: result.data,
        },
        null,
        year
      );
    } else {
      dispatchFetchVacancies(dispatch, false, null, result.error);
    }
    return result.data;
  } catch (ex) {
    dispatchFetchVacancies(dispatch, false, null, { error: ex.message });
    throw ex;
  }
};

export default fetchVacancies;
